<template>
  <div class="d-flex justify-content-center">
    <b-spinner variant="primary"/>
  </div>
</template>

<script>
export default {};
</script>
